import React from "react";
import { Box, Typography } from "@mui/material";

const SizeSelector = ({ sizes }) => {
  if (!sizes || sizes.length === 0) return null;

  const isAvailable = (sizeObj) => {
    return sizeObj.availability !== "false" && sizeObj.availability !== false && sizeObj.available !== false;
  };

  return (
    <Box>
      <Typography
        sx={{
          fontFamily: "Poppins-SemiBold",
          fontSize: "14px",
          color: "#1a1a1a",
          mb: 1.5,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        Size
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 1.5,
          overflowX: "auto",
          pb: 1,
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
        }}
      >
        {sizes.map((sizeObj, index) => {
          const available = isAvailable(sizeObj);
          
          return (
            <Box
              key={index}
              sx={{
                flexShrink: 0,
                minWidth: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "12px",
                border: available ? "1px solid #ddd" : "1px solid #eee",
                backgroundColor: available ? "#fff" : "#f9f9f9",
                cursor: "default",
                position: "relative",
                opacity: available ? 1 : 0.6,
                // Strikethrough for unavailable
                "&::after": !available ? {
                  content: '""',
                  position: "absolute",
                  top: "50%",
                  left: "-5%",
                  right: "-5%",
                  height: "1.5px",
                  backgroundColor: "#FF3B30",
                  transform: "rotate(-45deg)",
                  transformOrigin: "center",
                } : {}
              }}
            >
              <Typography
                sx={{
                  fontFamily: available ? "Poppins-SemiBold" : "Poppins-Medium",
                  fontSize: "14px",
                  color: available ? "#1a1a1a" : "#aaa",
                }}
              >
                {sizeObj.size}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default SizeSelector;
